import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LocalSaveService } from './local-save-service.service';
import { environment } from 'src/environments/environment';

export class Data {
  constructor(
    public usuario: any,
  ) { }
}

@Injectable({
  providedIn: 'root'
})
export class AppServiceService {

  private globalip: string = environment.baseUrl;
  private authip: string = environment.authBaseUrl;
  token = this._localsave.get('token');

  public Data = new Data(
    null,
  );

  constructor(
    public http: HttpClient,
    public _localsave: LocalSaveService,
  ) { }

  login(params) {
    return this.http.post(this.globalip + '/api/auth', params);
  }

  getUsuarios() {
    return this.http.post(
      this.globalip + '/api/socma/usuario/getall',
      {},
      { headers: { 'Authorization': 'p ' + this.token } }
    );
  }

  reqResetPwd(params: any) {
    return this.http.post(this.authip + '/auth/reqresetpwd', params);
  }
}
